import { useEffect, useState } from "react";
import { Modal, Select, message } from "antd";
import { useTranslation } from "react-i18next";

import { MISSING_TRANSLATION } from "../../../../../i18n";
import { IUser } from "../../../../../types";
import {
  filterOperatorOption,
  listOperators,
  operatorName,
  setCustomerManager,
} from "../../../../../../modules/integrations/accounts";
import { Operator } from "@/providers/smarta-accounts/accounts-api-client";

const { Option } = Select;

interface AssignClientModalProps {
  user: IUser;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const AssignClientModal = ({
  user,
  open,
  onClose,
  onSuccess,
}: AssignClientModalProps) => {
  const { t } = useTranslation();
  const [operators, setOperators] = useState<Operator[]>([]);
  const [selectedId, setSelectedId] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setOperators([]);
      setSelectedId(undefined);
      listOperators()
        .then((data) => setOperators(data))
        .catch(() => {
          setOperators([]);
          message.error("An error occurred");
        });
    }
  }, [open]);

  const handleOk = async () => {
    if (!selectedId) return;
    setLoading(true);
    try {
      await setCustomerManager(user.publicId, selectedId);
      message.success(t("assignClient") || MISSING_TRANSLATION);
      onSuccess();
      onClose();
    } catch {
      message.error("An error occurred");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={t("assignKamModalTitle") || MISSING_TRANSLATION}
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      okButtonProps={{ disabled: !selectedId, loading }}
      destroyOnClose
    >
      <Select
        showSearch
        style={{ width: "100%" }}
        placeholder={t("assignee") || MISSING_TRANSLATION}
        value={selectedId}
        onChange={(val) => setSelectedId(val)}
        filterOption={filterOperatorOption(operators)}
      >
        {operators.map((op) => (
          <Option key={op.id} value={op.id}>
            {operatorName(op)}
          </Option>
        ))}
      </Select>
    </Modal>
  );
};

export default AssignClientModal;
